export const MARQUE_SEARCH_SUCCES = "MARQUE_SEARCH_SUCCES";
export const MARQUE_SEARCH_ECHEC = "MARQUE_SEARCH_ECHEC";
export const MARQUE_SEARCH_RESET = "MARQUE_SEARCH_RESET";
export const MARQUE_SEARCH_REQUETTE = "MARQUE_SEARCH_REQUETTE";
